import React from 'react'
import { CoachCard } from './CoachCard'
import type { Coach } from '../../Api'
import { CoachOuter, CoachRow } from './styles'

type CoachCardsGroupProps = { coaches: Coach[] }

export const CoachCardsGroup: React.FC<
  React.PropsWithChildren<CoachCardsGroupProps>
> = ({ coaches }) => {
  return (
    <CoachRow>
      {coaches.map((coach) => (
        <CoachOuter key={coach.lastName} >
          <CoachCard coach={coach} />
        </CoachOuter>
      ))}
    </CoachRow>
  )
}

type SingleCoachProps = { coach: Coach | null }

export const SingleCoach: React.FC<React.PropsWithChildren<SingleCoachProps>> = ({
  coach,
}) => {
  if(!coach) return
  return (
    <CoachOuter>
      <CoachCard coach={coach} />
    </CoachOuter>
  )
}
